/**
 * * Модель запроса на получение списка статусов
 */
export default class GetListStatusRequest {
  /**
   * * Номер очереди задач
   */
  QueueTasksId!: Array<string>;
  /**
   * * Сортировка по названию
   */
  OrderByName?: boolean = false;
  /**
   * * Список глобальных статусов
   */
  GlobalStatusIds!: Array<string>;
  /**
   * * Поиск
   */
  Search!: string;

  constructor(obj?: Partial<GetListStatusRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
